module.exports = __webpack_public_path__ + "static/media/Week 6 Tuesday.d56a58cc.png";